import React from 'react';
import Spinner from './Spinner';

interface ActivatingTrialOverlayProps {
    isVisible: boolean;
}

const ActivatingTrialOverlay: React.FC<ActivatingTrialOverlayProps> = ({ isVisible }) => {
    if (!isVisible) {
        return null;
    }

    return (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
            <div className='bg-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 text-center'>
                <div className='mb-6'>
                    <div className='w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4'>
                        <Spinner size='lg' color='blue' />
                    </div>
                </div>
                <h2 className='text-2xl font-bold text-gray-900 mb-2'>Activating Free Trial</h2>
                <p className='text-gray-600 mb-4'>Please do not navigate away from the page</p>
                <div className='text-sm text-gray-500'>This may take a few moments...</div>
            </div>
        </div>
    );
};

export default ActivatingTrialOverlay;
